import Loadable, {Loader} from "./Loadable";
import ScrollTop from "./ScrollTop";
import MainLayout from "./layout/MainLayout";
import MinimalLayout from "./layout/MinimalLayout";
import { GlobalErrorBoundary } from "./GlobalErrorBoundry";
import PaginationComponent from "./pagination"; 

export {
  Loadable,
  Loader,
  ScrollTop,
  MainLayout,
  MinimalLayout,
  GlobalErrorBoundary,
  PaginationComponent
} 